import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Phone, ArrowRight } from '@/components/ui/Icons';
import { company } from '@/data/company';

export function CTABand({
  heading = `Looking for a reliable local contractor in ${company.serviceCoverage}?`,
  subheading = 'Free quotes. No call-out charges. All work guaranteed.',
}: { heading?: string; subheading?: string }) {
  return (
    <section className="relative isolate overflow-hidden bg-navy-900 text-paper-0">
      <div
        aria-hidden="true"
        className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_25%_15%,rgba(184,145,70,0.18),transparent_55%),radial-gradient(circle_at_85%_90%,rgba(39,69,112,0.4),transparent_60%)]"
      />
      <div className="container-page py-16 lg:py-20">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center"
        >
          <div className="max-w-2xl">
            <h2 className="font-display text-3xl font-semibold leading-tight sm:text-4xl/10">{heading}</h2>
            <p className="mt-3 text-base text-paper-0/80 sm:text-lg">{subheading}</p>
          </div>
          <div className="flex flex-wrap gap-3">
            <Link to="/contact" className="btn-gold group">
              Get a quote
              <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
            <a href={`tel:${company.phoneTel}`} className="btn-outline-gold">
              <Phone className="h-4 w-4" />
              {company.phone}
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
